import { service } from '../../../../helpers/http' 

export const ActionGetTypeSubscriptions = ({ dispatch }, payload) => { 
    return service({
        module: 'domainTypeSubscription',
        action: 'getTypeSubscriptions',
        payload: payload
    })
}

export const ActionGetTypeInstitutionSubscriptions = ({ dispatch }, payload) => { 
    return service({
        module: 'domainTypeSubscription',
        action: 'getTypeInstitutionSubscriptions',
        payload: payload
    })
}

export const ActionPostTypeInstitutionSubscriptions = ({ dispatch }, payload) => {

    return service({
        module: 'domainTypeSubscription',
        action: 'postTypeInstitutionSubscriptions',
        payload: payload
    })
    
}

export const ActionPutTypeInstitutionSubscriptions = ({ dispatch }, payload) => {

    return service({
        module: 'domainTypeSubscription',
        action: 'putTypeInstitutionSubscriptions',
        payload: payload
    })
    
}

export const ActionDeleteTypeInstitutionSubscriptions = ({ dispatch }, payload) => {

    return service({
        module: 'domainTypeSubscription',
        action: 'deleteTypeInstitutionSubscriptions',
        payload: payload
    })
    
}
